import React from 'react';
import backToServiceTitanSvg from './images/back-to-servicetitan.svg';
import { SimpleHeaderContainer } from './styles';

const SimpleHeader = ({
  toggleDisplaySimpleHeader,
  toggleDisplayMainHeader,
  altText = 'Back To ServiceTitan',
}) => (
  <SimpleHeaderContainer
    onClick={() => {
      toggleDisplaySimpleHeader(false);
      toggleDisplayMainHeader(true);
    }}
  >
    <div className="simple-header--link">
      <img src={backToServiceTitanSvg} alt={altText} />
    </div>
  </SimpleHeaderContainer>
);

export default SimpleHeader;
